import { Injectable, inject } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private modalService = inject(NgbModal);


  open(content: any, options: any = {}): NgbModalRef {
    return this.modalService.open(content, options);
  }

  openFromComponent(component: any, options: any = {}): NgbModalRef {
    return this.modalService.open(component, options);
  }

  closeAll(): void {
    this.modalService.dismissAll();
  }
}
